import React, { useRef } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Result from './result';

const ResultModal = ({ user, validations, hanndleNextQuestion, items, response_range, section, prevState }) => {
  const modalRef = useRef(null);

  const toggle = () => {
    if(user?.talents?.length) {
      return;
    }
    hanndleNextQuestion('rearrenge');
  }

  return (
    <>
      <Modal 
        isOpen={true} 
        size={'lg'} 
        toggle={toggle} 
        className='close-circle'
        innerRef={modalRef}
      >
        {!user?.talents?.length > 0 && <ModalHeader toggle={toggle} style={{borderBottom:'0'}} />}
        <ModalBody>
          <Result 
            key="result" 
            user={user} 
            validations={validations} 
            hanndleNextQuestion={hanndleNextQuestion} 
            items={items} 
            response_range={response_range} 
            section={section} 
            prevState={prevState} 
          />
        </ModalBody>
      </Modal>
    </>
  )
}

export default ResultModal;